//const appUrl = 'https://gprocolombia.mybluemix.net';
const appUrl = 'http://localhost:3000';

export { appUrl };